
export class Faq {
	// identifiers
	id;
	slug;
	
	title;
	question
	
	constructor (object)
	{		
		console.log("🤔 FAQ:", object )
		// identifiers
		this.id = object.id || null;
		this.author = object.author || null;
		this.date = object.date || null;
		this.status = object.status || null;
		this.slug = object.slug || null;
		this.title = object.title.rendered || null;

		this.answer = object.meta_box.faq_answer || null;
		
	}
}



// WEBPACK FOOTER //
// ./src/data/classes/faq.class.js